/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const ADD_TAG = gql`
  mutation AddTag($name: String!) {
    addTag(name: $name) {
      id
      name
    }
  }
`
